function isPlainObject(value) {
    const prototype = Object.getPrototypeOf(value);
    return prototype === Object.prototype || prototype === null;
}
export function isRecord(value) {
    return (typeof value === 'object' && value !== null && !Array.isArray(value) && isPlainObject(value));
}
function isJsonValueInternal(value, seen) {
    if (value === null || typeof value === 'string' || typeof value === 'boolean')
        return true;
    if (typeof value === 'number')
        return Number.isFinite(value);
    if (Array.isArray(value)) {
        if (seen.has(value))
            return false;
        seen.add(value);
        const valid = value.every((entry) => isJsonValueInternal(entry, seen));
        seen.delete(value);
        return valid;
    }
    if (!isRecord(value) || seen.has(value))
        return false;
    seen.add(value);
    const valid = Object.values(value).every((entry) => isJsonValueInternal(entry, seen));
    seen.delete(value);
    return valid;
}
export function isJsonObject(value) {
    return isRecord(value) && isJsonValueInternal(value, new WeakSet());
}
export function isJsonValue(value) {
    return isJsonValueInternal(value, new WeakSet());
}
export class ConfigParseError extends TypeError {
    path;
    constructor(path, reason) {
        super(`${path}: ${reason}`);
        this.name = 'ConfigParseError';
        this.path = path;
    }
}
export function parseNonEmptyText(value, path) {
    if (typeof value !== 'string' || value.trim().length === 0) {
        throw new ConfigParseError(path, 'must be a non-empty string');
    }
    if ([...value].some((character) => character.charCodeAt(0) < 0x20 || character === '\u007f')) {
        throw new ConfigParseError(path, 'must not contain control characters');
    }
    return value.trim();
}
export function parseOptionalText(value, path) {
    if (value === undefined || value === null || value === '')
        return undefined;
    return parseNonEmptyText(value, path);
}
export function parseInteger(value, path, minimum, maximum) {
    const numeric = typeof value === 'number'
        ? value
        : typeof value === 'string' && /^[+-]?\d+$/.test(value.trim())
            ? Number(value.trim())
            : Number.NaN;
    if (!Number.isSafeInteger(numeric) || numeric < minimum || numeric > maximum) {
        throw new ConfigParseError(path, `must be an integer between ${minimum} and ${maximum}`);
    }
    return numeric;
}
export function parsePositiveDecimal(value, path) {
    const numeric = typeof value === 'number' ? value : typeof value === 'string' ? Number(value) : NaN;
    if (!Number.isFinite(numeric) || numeric <= 0) {
        throw new ConfigParseError(path, 'must be a positive finite number');
    }
    return numeric;
}
//# sourceMappingURL=types.js.map